import {
	AnyHighlightChildRequest,
	ElementType,
	HighlightsSectionRequest,
	UnfilledHighlightsButtonComponent,
} from '../model';

export function isHighlightsSection(item: AnyHighlightChildRequest): item is HighlightsSectionRequest {
	return Array.isArray((item as HighlightsSectionRequest)?.elements);
}

export function isUnfilledButton(item: AnyHighlightChildRequest | UnfilledHighlightsButtonComponent): item is UnfilledHighlightsButtonComponent {
	if (item.type !== ElementType.BUTTON) {
		return false;
	}
	return item.meta.action === null;
}

export function isNew(item: AnyHighlightChildRequest): boolean {
	return Boolean(item.newId && !item.id);
}
